import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';

import { RolesRoutingModule } from './roles-routing.module';
import { RolesComponent } from './roles.component';
import { ListarRolesComponent } from './listar-roles/listar-roles.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { AsigRolUsuComponent } from './asig-rol-usu/asig-rol-usu.component';
import { SharedModule } from '../shared.module';
import { ConsRolFuncUsuComponent } from './cons-rol-func-usu/cons-rol-func-usu.component';

@NgModule({
  declarations: [
    RolesComponent,
    ListarRolesComponent,
    AsigRolUsuComponent,
    ConsRolFuncUsuComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    NgxPaginationModule,
    RolesRoutingModule,
    SharedModule
  ]
})
export class RolesModule { }
